define(
    'providers/dataprovider.libraries',[
        "services/config"
    ],
    function(config) {

        function getLibraries() {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-libraries-libraries",
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function getTemplateDocuments(libraryId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-libraries-template-documents",
                    data: { libraryId : libraryId},
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function getLibrariesLookup() {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-libraries-librarieslookup",
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function getLibraryById(id) {
            var data = { id: id };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-libraries-librarybyid",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function getDashboard(id) {
            var data = { id: id };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-libraries-dashboard",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function getSettings(id) {
            var data = { id: id };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-libraries-settings",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function getDisplay(id) {
            var data = { id: id };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-libraries-display",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function getProfileFieldLookups(libraryId) {
            var data = { libraryId: libraryId };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-libraries-displayfieldlookups",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        
        function getProfileFieldValues(lookupId, libraryId) {
            var data = { lookupId: lookupId, libraryId: libraryId };
            
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-libraries-displayfieldvalues",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function deleteLibrary(id) {
            var data = { id: id };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "del-libraries-library",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function emptyLibrary(id, isFoldersAlso) {
            var resourceId = "emp-libraries-library";

            if (isFoldersAlso)
                resourceId = "emp-libraries-library-purge-folders";

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: resourceId,
                    data: { id: id },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function deleteProfileFieldValues(lookupId, id) {
            var data = {
                lookupId: lookupId,
                id: id
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "del-libraries-profilefieldvalues",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function createFromScratch(name, listId, repositoryId, isSendEmail) {
            var data = {
                name: name,
                description: '',
                ListId: listId,
                RepositoryId: repositoryId,
                sendNextStepEmail: isSendEmail,
                DuplicateLibraryId: null,
                TemplateId: null
            };
            
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "pos-libraries-fromscratch-duplicate-template",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function createDuplicate(libraryId, name, listId, repositoryId, isSendEmail) {
            var data = {
                name: name,
                description: '',
                ListId: listId,
                RepositoryId: repositoryId,
                sendNextStepEmail: isSendEmail,
                DuplicateLibraryId: libraryId,
                TemplateId: null
            };
            
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "pos-libraries-fromscratch-duplicate-template",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function createFromTemplate(data) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "pos-libraries-fromscratch-duplicate-template",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function createProfileFieldValues(lookupId, data) {
            var data = {
                lookupId: lookupId,
                name: data.name,
                isIncluded: data.isIncluded
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "pos-libraries-profilefieldvalues",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function updateSettings(id, name, isDisabled, repositoryId, isTemplateSource) {
            var data = {
                id: id,
                name: name,
                isDisabled: isDisabled,
                repositoryId: repositoryId,
                isTemplateSource: isTemplateSource
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-libraries-settings",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function updateName(id, name) {
            var data = {
                id: id,
                name: name
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-libraries-name",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function updateDisplay(id, taken) {
            var data = {
                id: id, columnsToDisplay: taken
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-libraries-display",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function updateProfileFields(libraryId, data) {
            var data = {                
                libraryId: libraryId,
                profileFieldVisibility: data
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-libraries-displayfieldlookups",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function updateProfileFieldValues(id, lookupId, data) {
            var data = {
                id: id,
                lookupId: lookupId,
                name: data.name,
                isIncluded: data.isIncluded
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-libraries-profilefieldvalues",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function resetColumns(id) {
            var data = {
                id: id
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-libraries-reset-columns",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function includeProfileFieldValueToLibrary(id, libraryId, isIncluded) {
            var data = {
                id: id,
                libraryId: libraryId
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: isIncluded ? "pos-libraries-profilefieldvaluetolibrary" : "del-libraries-profilefieldvaluetolibrary",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        init();

        return {
            getLibraries: getLibraries,
            getTemplateDocuments: getTemplateDocuments,
            getLibrariesLookup: getLibrariesLookup,
            getLibraryById: getLibraryById,
            getDashboard: getDashboard,
            getSettings: getSettings,
            getDisplay: getDisplay,
            getProfileFieldLookups: getProfileFieldLookups,
            getProfileFieldValues: getProfileFieldValues,
            deleteLibrary: deleteLibrary,
            emptyLibrary: emptyLibrary,
            deleteProfileFieldValues: deleteProfileFieldValues,
            createFromScratch: createFromScratch,
            createDuplicate: createDuplicate,
            createFromTemplate: createFromTemplate,
            createProfileFieldValues:createProfileFieldValues,
            updateSettings: updateSettings,
            updateName: updateName,
            updateDisplay: updateDisplay,
            updateProfileFields: updateProfileFields,
            updateProfileFieldValues: updateProfileFieldValues,
            resetColumns: resetColumns,
            includeProfileFieldValueToLibrary: includeProfileFieldValueToLibrary
        };

        //#region Internal Methods

        function init() {

            amplify.request.define("get-libraries-libraries", "ajax", {
                url: getUrl("libraries"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-libraries-template-documents", "ajax", {
                url: getUrl("documents/libraries/templatedocuments/{libraryId}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-libraries-librarieslookup", "ajax", {
                url: getUrl("admin/libraries/list/lookup"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-libraries-librarybyid", "ajax", {
                url: getUrl("libraries/{id}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-libraries-dashboard", "ajax", {
                url: getUrl("libraries/dashboard/{id}"),
                dataType: "json",
                type: "GET"
            });
            
            amplify.request.define("get-libraries-settings", "ajax", {
                url: getUrl("admin/libraries/settings/{id}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-libraries-display", "ajax", {
                url: getUrl("admin/libraries/display/{id}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-libraries-displayfieldlookups", "ajax", {
                url: getUrl("admin/libraries/profile/{libraryId}"),
                dataType: "json",
                type: "GET"
            });            

            amplify.request.define("get-libraries-displayfieldvalues", "ajax", {
                url: getUrl("admin/lookups/librarylookupvalues/{lookupId}/{libraryId}"),                
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("del-libraries-library", "ajax", {
                url: getUrl("admin/libraries/{id}"),
                dataType: "json",
                type: "DELETE"
            });

            amplify.request.define("emp-libraries-library", "ajax", {
                url: getUrl("admin/libraries/{id}/empty"),
                contentType: "application/json",
                dataType: "json",
                type: "DELETE"
            });
            amplify.request.define("emp-libraries-library-purge-folders", "ajax", {
                url: getUrl("admin/libraries/{id}/empty/purgefolders"),
                contentType: "application/json",
                dataType: "json",
                type: "DELETE"
            });

            amplify.request.define("del-libraries-profilefieldvalues", "ajax", {
                url: getUrl("admin/lookups/{lookupId}/{id}"),
                contentType: "application/json",
                dataType: "json",
                type: "DELETE"
            });

            amplify.request.define("pos-libraries-fromscratch-duplicate-template", "ajax", {
                url: getUrl("admin/libraries"),
                contentType: "application/json",
                dataType: "json",
                type: "POST",
                dataMap: function (data) { return JSON.stringify(data); }
            });

            amplify.request.define("pos-libraries-profilefieldvalues", "ajax", {
                url: getUrl("admin/lookups/{lookupId}"),
                contentType: "application/json",
                dataType: "json",
                type: "POST",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("put-libraries-settings", "ajax", {
                url: getUrl("admin/libraries/settings/{id}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("put-libraries-name", "ajax", {
                url: getUrl("admin/libraries/settings/{id}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("put-libraries-display", "ajax", {
                url: getUrl("admin/libraries/display/{id}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("put-libraries-displayfieldlookups", "ajax", {
                url: getUrl("admin/libraries/profile/{libraryId}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("put-libraries-profilefieldvalues", "ajax", {
                url: getUrl("admin/lookups/{lookupId}/{id}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("pos-libraries-profilefieldvaluetolibrary", "ajax", {
                url: getUrl("admin/lookups/addlookupvaluetolibrary/{id}/{libraryId}"),
                contentType: "application/json",
                dataType: "json",
                type: "POST",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("put-libraries-reset-columns", "ajax", {
                url: getUrl("admin/libraries/display/{id}/reset"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("del-libraries-profilefieldvaluetolibrary", "ajax", {
                url: getUrl("admin/lookups/addlookupvaluetolibrary/{id}/{libraryId}"),
                contentType: "application/json",
                dataType: "json",
                type: "DELETE",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });
        }

        function getUrl(action) {
            return config.webApiUrl + action;
        }

        //#endregion
    }
);
